import callCmAPI from 'services/helpers/call-cm-api'
/******************
 * Fetch from API *
 ******************/

export const deleteOnlyApiUser = (apiUserId) => {
  return callCmAPI(`/user/api/${apiUserId}`, {
    method: 'delete',
  })
}
